import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { googleAdsGetProductDetails } from 'sprites-types/workflow/tools/googleAdsGetProductDetails'
import { ObjectDisplay } from '../shared/ObjectDisplay'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'
import { SchemaValidationError } from '../shared/safeParseToolResult'

function GoogleAdsGetProductDetailsDisplayComponent({ nodeExecution }: WorkflowToolComponentProps) {
  const schema = getToolResultSchema(googleAdsGetProductDetails, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-gray-900">Product Details Results</h3>
      <ObjectDisplay data={result} />
    </div>
  )
}

async function downloadGoogleAdsProductPerformance(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function googleAdsGetProductDetailsToMarkdown(nodeExecution: NodeExecution): string {
  const schema = getToolResultSchema(googleAdsGetProductDetails, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return '## Error: Schema validation failed\n\nUnable to export results due to data structure mismatch.'
  }

  const result = parseResult.data
  return `## Google Ads Product Details\n\n\`\`\`json\n${JSON.stringify(result, null, 2)}\n\`\`\`\n\n---`
}

export const GoogleAdsGetProductDetailsDisplay = createWorkflowToolComponent(
  GoogleAdsGetProductDetailsDisplayComponent,
  downloadGoogleAdsProductPerformance,
  googleAdsGetProductDetailsToMarkdown
)
